import React from "react";
import { Box, Typography, Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../Utils/constants";

const DeleteConfirmationPopup = ({ open, onClose, heading, message, onConfirm, errorMessage }) => {
    const { t } = useTranslation();
    const { mode } = useThemeContext();
    const borderColor1 = mode === 'dark' ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;
    const btnColor = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;

    return (
        <Modal open={open} onClose={onClose} closeAfterTransition>
            <Box className="save-sec"
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: "8px",
                    width: "500px",
                }}
            >
                <h2 className='addmachine-text-heading1'>{heading}</h2>
                <p id="save-changes-text" style={{}} className=' word-break'>{message}</p>
                {errorMessage && (
                    <Typography sx={{ color: 'red', marginTop: '8px' }}>{errorMessage}</Typography>
                )}
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>

                    {/* Cancel Button */}
                    <button type="button" style={{ color: btnColor, borderColor: btnColor }} className='cancel-btn' onClick={onClose}>{t('membershipCards.cancel')}</button>

                    {/* Save Button */}
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={!!errorMessage}
                        style={{ background: borderColor1, opacity: !!errorMessage ? 0.6 : 1 }}
                        className='save-btn'
                    >
                        {t('membershipCards.delete')}
                    </button>

                </Box>
            </Box>
        </Modal>
    );
};

export default DeleteConfirmationPopup;
